import * as utils from '../../../util';
import type { StandardChartLayerSpec } from '../../../core/layer';

// 通用字段验证工厂函数
export const createFieldValidator =
  (field: keyof StandardChartLayerSpec['encoding']) =>
  (layer: StandardChartLayerSpec, needArray: boolean = false) => {
    const { encoding } = layer;
    const fieldValue = encoding[field];
    if (!fieldValue) {
      utils.logger.warn('warning', `The "${field}" field of the "${layer.type}" layer is required`);
      return false;
    }
    if (!needArray && Array.isArray(fieldValue)) {
      utils.logger.warn(
        'warning',
        `The "${field}" field of the "${layer.type}" layer must be a single field`
      );
      return false;
    }
    return true;
  };

export const isFieldValid = (
  layer: StandardChartLayerSpec,
  fieldName: keyof StandardChartLayerSpec['encoding']
) => {
  const { encoding } = layer;
  if (encoding[fieldName] && Array.isArray(encoding[fieldName])) {
    utils.logger.warn(
      'warning',
      `The "${fieldName}" field of the "${layer.type}" layer must be a single field`
    );
    return false;
  }
  return true;
};

const isStringType = (value: unknown) => {
  return typeof value === 'string';
};

const isDateType = (value: unknown) => {
  return value instanceof Date || !Number.isNaN(new Date(value as string).getTime());
};

const isNumberType = (value: unknown) => {
  return typeof value === 'number' || (!Number.isNaN(Number(value)) && typeof value !== 'boolean');
};

/**
 * 检查字段类型是否符合要求
 * @param values 数据数组
 * @param field 字段名
 * @param expectedType 期望类型
 * @returns 类型是否符合要求
 */
export function checkFieldType(
  values: any[],
  field: string,
  expectedType: 'string' | 'date' | 'number' | 'array'
): boolean {
  if (!values.length || !values.some(item => Object.prototype.hasOwnProperty.call(item, field))) {
    return false;
  }

  return values.some(item => {
    const value = item[field];

    // 允许空值但类型必须匹配
    switch (expectedType) {
      case 'string':
        return isStringType(value);
      case 'date':
        return isDateType(value);
      case 'number':
        return isNumberType(+value);
      case 'array':
        return Array.isArray(value);
      default:
        return false;
    }
  });
}
